import React, { useEffect, useState } from 'react';
import { useAtom, useSetAtom } from 'jotai';
import {
  approvalFilter,
  approvalTempFilter,
  initTempFilter,
  webApprovalState,
} from '@/recoil/atom';
import { INIT_WEB_APPROVAL_FILTER_STATE } from '@/recoil/init_data';
import Content from '@/components/Approval/Content';

export const MAX_APPROVAL_LIST_SIZE = 20;

const Approval = () => {
  const [filters, setFilters] = useAtom(approvalFilter);
  const setTempFilters = useSetAtom(approvalTempFilter);
  const [approvalState, setApprovalState] = useAtom(webApprovalState);
  const [csrReady, setCsrReady] = useState(false);

  useEffect(() => {
    setCsrReady(true);
  }, []);

  useEffect(() => {
    if (!sessionStorage.getItem('approvalFilterState')) {
      setFilters({ ...INIT_WEB_APPROVAL_FILTER_STATE });
    } else {
      if (
        filters.finalApproverPassportIds === undefined ||
        filters.searchFields === undefined
      ) {
        setFilters({ ...INIT_WEB_APPROVAL_FILTER_STATE });
      }
      setTempFilters(initTempFilter(filters));
    }
  }, []);

  useEffect(() => {
    const foldMenuWhenWindowIsResized = () => {
      // 화면 너비 줄여서 화면 크키가 1440 작을 때 메뉴 접힘 적용
      if ((window.innerWidth ?? 0) < 1440) {
        setApprovalState({ ...approvalState, open: false });
      }
    };
    window.addEventListener('resize', foldMenuWhenWindowIsResized);
    foldMenuWhenWindowIsResized(); // 초기값 설정

    return () => {
      window.removeEventListener('resize', foldMenuWhenWindowIsResized);
    };
  }, []);

  return csrReady ? <Content /> : null;
};

export default Approval;
